(function (window, document) {
  'use strict';
  window.JN = window.JN || {};
  function get(url, signal) {
    return fetch(url, {credentials: 'same-origin', signal: signal}).then(function (response) {
      if (!response.ok) throw new Error('status unavailable');
      return response.json();
    }).then(function (state) {
      if (state.status !== 'OK' || !Array.isArray(state.samples)) throw new Error('invalid state');
      return state;
    });
  }
  function poll(url, onState, onStop) {
    var deadline = Date.now() + 90000;
    var timer;
    var controller;
    var stopped = false;
    function stop(reason) {
      if (stopped) return;
      stopped = true;
      clearTimeout(timer);
      if (controller) controller.abort();
      window.removeEventListener('pagehide', leave);
      if (onStop) onStop(reason);
    }
    function leave() { stop('navigation'); }
    window.addEventListener('pagehide', leave);
    function next(delay) {
      if (Date.now() >= deadline) return stop('timeout');
      timer = setTimeout(function () {
        if (Date.now() >= deadline) return stop('timeout');
        controller = new AbortController();
        var requestTimer = setTimeout(function () { controller.abort(); }, Math.min(10000, deadline - Date.now()));
        get(url, controller.signal).then(function (state) {
          clearTimeout(requestTimer);
          if (stopped) return;
          if (onState(state) === false) return stop('complete');
          next(Math.min(delay * 1.5, 10000));
        }).catch(function () {
          clearTimeout(requestTimer);
          if (!stopped) next(Math.min(delay * 1.5, 10000));
        });
      }, Math.min(delay, deadline - Date.now()));
    }
    next(1500);
    return stop;
  }
  function render(container, sample) {
    var signature = JSON.stringify([sample.status_label, sample.busy, sample.note, sample.sync_note, sample.next_retry_at]);
    if (container.dataset.articleState === signature) return;
    container.dataset.articleState = signature;
    delete container.dataset.updatesPaused;
    container.textContent = '';
    container.setAttribute('role', 'status');
    container.setAttribute('aria-live', 'polite');
    var label = document.createElement('span');
    label.className = 'pill ' + (sample.busy ? 'info' : ['manual', 'succeeded'].includes(sample.status) ? 'success' : 'warning');
    label.textContent = sample.status_label || '';
    container.appendChild(label);
    if (sample.note) {
      var note = document.createElement('span');
      note.className = 'tw-text-secondary-text';
      note.textContent = sample.note;
      container.appendChild(note);
    }
    if (sample.sync_note) {
      var sync = document.createElement('span');
      sync.className = 'tw-block tw-text-secondary-text';
      sync.textContent = sample.sync_note;
      container.appendChild(sync);
    }
    if (sample.next_retry_at) {
      var time = document.createElement('time');
      time.dateTime = sample.next_retry_at;
      time.textContent = window.JN.t('js.ingestion.next_retry') + ' ' + new Date(sample.next_retry_at).toLocaleString(document.documentElement.lang);
      container.appendChild(time);
    }
  }
  function unavailable(container) {
    if (container.dataset.updatesPaused) return;
    container.dataset.updatesPaused = '1';
    var note = document.createElement('span');
    note.className = 'tw-block tw-text-secondary-text';
    note.textContent = window.JN.t('js.ingestion.paused');
    container.appendChild(note);
  }
  window.JN.articleStatus = {poll: poll, render: render, unavailable: unavailable, get: get};
})(window, document);
